import React from 'react';
import PropTypes from 'prop-types';
import * as types from '../../../constants/actionTypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from '../../../actions/baselineActions';
import { withRouter } from 'react-router';
import BaselineForm from './BaselinesForm';
import { DEFAULT_PAGE_SIZE, MOBILE_WINDOW_BREAKPOINT } from '../../../constants/constants';
import Routes from '../../../constants/routes';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import Drawer from '../../Common/Drawer/Drawer';
import Icon from '../../Common/Icon';
import Notification from '../../../components/Common/Notification';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import { Menu } from 'primereact/menu';
import BaselinePushdownForm from './BaselinePushdownForm';
import BaselineCopyDrawer from './BaselineCopyDrawer';
import DocumentTitle from 'react-document-title';
import { getDataTableSortFields, getSearchParamSortFields } from '../../../helpers/sortHelper';
import { getOnActiveChangeValue } from '../../../helpers/multiselect';

const ACTION_MENU_OPTIONS = {
    EditProfile: 'editProfile',
    ViewTaskList: 'viewTaskList',
    BaselinePushdown: 'viewBaselinePushdown',
    ViewCopyBaseline: 'viewCopyBaseline'
};

export class Baselines extends React.Component {

    constructor(props, context) {
        super(props, context);

        const newBaseline = {
            id: 0,
            name: "",
            description: "",
            isActive: true,
            subscriptionId: props.subscriptionId,
            jobTitles: [],
            users: []
        };

        this.state = {
            baselines: [],
            totalCount: 0,
            isFetching: false,
            isSaving: false,
            selectedBaseline: newBaseline,
            editBaseline: newBaseline,
            newBaseline: newBaseline,
            drawerOpen: false,
            pushdownDrawerOpen: false,
            copyBaselineDrawerOpen: false,
            isCopyLoading: false,
            isFormValid: true,
            isPushdownFormValid: true,
            errorMessage: "",
            editAction: "",
            pushdownLocationList: [],
            locationsToPush: [],
            projectEnabled: false,
            isPushdownLoading: false,
            searchParams: {
                subscriptionId: props.subscriptionId,
                isActive: true,
                pageSize: DEFAULT_PAGE_SIZE,
                pageNumber: 1,
                sortBy: "name",
                sortDir: "asc",
                name: ""
            }
        };
        this.search.bind(this);
        this.copyBaseline.bind(this);
    }

    async componentDidMount() {
        await this.search();
        await this.loadLocations();
    }

    async search() {
        try {
            this.setState({ isFetching: true });
            const result = await this.props.actions.searchBaselines(this.state.searchParams);
            const payload = result.payload;
            if (result.type === types.SEARCH_BASELINE_SUCCESS) {
                this.setState({ baselines: payload.results, totalCount: payload.totalCount });
            } else if (result.type === types.SEARCH_BASELINE_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        } finally {
            this.setState({ isFetching: false });
        }
    }

    async loadLocations() {
        try {
            const response = await this.props.actions.loadPushdownLocations();
            if (response.type === types.LOAD_PUSHDOWN_LOCATIONS_SUCCESS) {
                this.setState({ pushdownLocationList: response.payload.locations, projectEnabled: response.payload.isProjectFeatureEnabled });
            } else if (response.type === types.LOAD_PUSHDOWN_LOCATIONS_FAILURE) {
                Notification("error", "An Error Occurred", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        }
    }

    filterChange = (e) => {
        let name = e.target.name;
        this.setState({ searchParams: { ...this.state.searchParams, [name]: e.target.value } });
    }

    onSearchBlur = () => {
        this.search();
    }

    keyUpFilter = (e) => {
        if (e.keyCode == 13) {
            this.search();
        }
    }

    onActiveChange = (e) => {
        const selectedValue = getOnActiveChangeValue(e);
    
        this.setState(prevState => ({
            searchParams: {
                ...prevState.searchParams,
                isActive: selectedValue
            }
        }), () => {
            this.search();
        });
    }

    onPageChange = (e) => {
        this.setState({ searchParams: { ...this.state.searchParams, pageNumber: (e.page + 1) } }, () => {
            this.search();
        });
    }

    onAddNew = () => {
        this.setState({ selectedBaseline: null, editBaseline: this.state.newBaseline, drawerOpen: true, errorMessage: "", isFormValid: true, editAction: "edit" });
    }

    onTextChange = (name, value) => {
        this.setState({
            ...this.state,
            [name]: value
        });
    }

    // ------- Drawer
    saveClick = () => {
        this.setState({
            drawerOpen: false,
            searchParams: { ...this.state.searchParams, pageNumber: 1 }
        },
            () => { this.search(); });
    }

    updateLocationsToPush = (locations) => {
        this.setState({ locationsToPush: locations, isPushdownFormValid: true });
    }

    pushdownClick = () => {
        if (this.state.locationsToPush.length < 1) {
            this.setState({ isPushdownFormValid: false });
        }
        else {
            this.pushdown();
        }
    }

    copyBaseline = async (name, description) => {
        try {
            this.setState({ isCopyLoading: true });

            const requestObj = {
                name,
                description,
                baselineId: this.state.editBaseline.id
            }

            const result = await this.props.actions.copyBaseline(requestObj);

            if (result.type === types.COPY_BASELINE_SUCCESS) {
                Notification("success", "Copy Baseline Successful", "")
                this.setState({ copyBaselineDrawerOpen: false }, () => {
                    this.search();
                });
            } else if (result.type === types.COPY_BASELINE_FAILURE) {
                Notification("error", "An Error Occurred", result.payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        } finally {
            this.setState({ isCopyLoading: false });
        }
    }

    async pushdown() {
        try {
            this.setState({ isPushdownLoading: true });

            const requestObj = {
                locationIds: this.state.locationsToPush.map(x => x.id),
                baselineId: this.state.editBaseline.id
            }

            const result = await this.props.actions.pushdown(requestObj);

            if (result.type === types.PUSHDOWN_BASELINE_SUCCESS) {
                Notification("success", "Pushdown Successful", "Baseline pushdown successfull")
                this.setState({ pushdownDrawerOpen: false, locationsToPush: [] });
            } else if (result.type === types.PUSHDOWN_BASELINE_FAILURE) {
                Notification("error", "An Error Occurred", result.payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        } finally {
            this.setState({ isPushdownLoading: false });
        }
    }

    cancelClick = () => {
        this.setState({ drawerOpen: false, pushdownDrawerOpen: false, copyBaselineDrawerOpen: false });
    }

    selectBaseline = (e) => {
        const isEllipsisClick = e.originalEvent.target.className.indexOf('ellipsis-h') >= 0 || e.originalEvent.target.className.indexOf('ellipsis') >= 0;
        if (isEllipsisClick === true) {
            return;
        }

        this.setState({ selectedBaseline: e.value, editBaseline: e.value }, () => {
            this.viewBaselineTasks();
        });
    }
    // ------- Drawer

    activeTemplate = (rowData) => {
        if (rowData.isActive) {
            return <div className="text-success text-center"><Icon name="check-circle" /></div>;
        } else {
            return <div className="text-danger text-center"><Icon name="times-circle" /></div>;
        }
    }

    onActionsClick = (rowData, e) => {
        this.menu.toggle(e);
        this.setState({ selectedBaseline: rowData, editBaseline: rowData });
    }

    actionTemplate = (rowData) => {
        return <div className="text-center ellipsis" onClick={(e) => this.onActionsClick(rowData, e)}><Icon name="ellipsis-h" /></div>
    }

    menuOptionClick = (e) => {
        switch (e.item.value) {
            case ACTION_MENU_OPTIONS.EditProfile:
                this.setState({ editAction: e.item.value, drawerOpen: true, pushdownDrawerOpen: false, copyBaselineDrawerOpen: false, isFormValid: true });
                break;
            case ACTION_MENU_OPTIONS.ViewTaskList:
                this.viewBaselineTasks();
                break;
            case ACTION_MENU_OPTIONS.BaselinePushdown:
                this.viewPushdownDrawer(e);
                break;
            case ACTION_MENU_OPTIONS.ViewCopyBaseline:
                this.viewCopyBaseline(e);
                break;
        }
    }

    viewBaselineTasks = () => {
        this.props.history.push(Routes.BaselineTaskList + "/?bid=" + this.state.selectedBaseline.id);
    }

    viewPushdownDrawer = (e) => {
        if (this.state.pushdownLocationList.length > 0) {
            this.setState({ editAction: e.item.value, drawerOpen: false, copyBaselineDrawerOpen: false, pushdownDrawerOpen: true, isPushdownFormValid: true, locationsToPush: [] });
        }
        else {
            Notification("error", "Location Access", "You must have access to at least 1 location to perform a pushdown");
        }
    }

    viewCopyBaseline = (e) => {
        this.setState({ editAction: e.item.value, drawerOpen: false, pushdownDrawerOpen: false, copyBaselineDrawerOpen: true });
    }

    onSort = ({ sortField, sortOrder }) => {
        const { sortBy, sortDir } = getSearchParamSortFields(sortField, sortOrder);
        if (sortBy !== this.state.searchParams.sortBy || sortDir !== this.state.searchParams.sortDir) {
            this.setState({
                searchParams: {
                    ...this.state.searchParams,
                    sortBy: sortBy,
                    sortDir: sortDir
                }
            }, this.search);
        }
    }

    nameFilterElement = () => (
        <input type="text" name="name" className="p-inputtext" placeholder="Filter by Name" onBlur={this.onSearchBlur} onChange={this.filterChange} onKeyUp={this.keyUpFilter} value={this.state.searchParams.name} />

    );

    render() {

        const displayColumns = (this.props.windowWidth < MOBILE_WINDOW_BREAKPOINT) ? 'none' : '';

        const activeOptions = [
            { label: "Yes", value: true },
            { label: "No", value: false },
            { label: "All", value: null }
        ];

        const menuOptions = [
            { label: "Edit Baseline", value: "editProfile", command: this.menuOptionClick },
            { label: "View Task List", value: "viewTaskList", command: this.menuOptionClick },
            { label: "Copy Baseline", value: "viewCopyBaseline", command: this.menuOptionClick }
        ];

        const activeFilter = (
                    <Dropdown
                        className="ui-column-filter"
                        value={this.state.searchParams.isActive}
                        options={activeOptions}
                        optionLabel="label"
                        optionValue="value"
                        onChange={this.onActiveChange}
                        placeholder="Select an option"
                    />
                );

        const nameFilterElement = <div>
            <input type="text" name="name" className="p-inputtext" placeholder="Filter by Name" onBlur={this.onSearchBlur} onChange={this.filterChange} onKeyUp={this.keyUpFilter} value={this.state.searchParams.name} />
        </div>;

        const descriptionFilterElement = <div>
            <input type="text" name="description" className="p-inputtext" placeholder="Filter by Description" onBlur={this.onSearchBlur} onChange={this.filterChange} onKeyUp={this.keyUpFilter} value={this.state.searchParams.description} />
        </div>;

        const { sortField, sortOrder } = getDataTableSortFields(this.state.searchParams);

        return (
            <div>
                <DocumentTitle title="Admin" />
                <Menu model={menuOptions} popup={true} ref={el => this.menu = el} />
                {this.state.drawerOpen &&
                    <BaselineForm
                        cancelClick={this.cancelClick}
                        saveClick={this.saveClick}
                        baselineActions={this.props.actions}
                        baselineId={this.state.editBaseline.id}
                        subscriptionId={this.props.subscriptionId.toString()}
                    />
                }

                {this.state.pushdownDrawerOpen ?
                    <Drawer isWide={false} title={this.state.editBaseline.name} saveText="Push" onSaveClick={this.pushdownClick} onCancelClick={this.cancelClick}>
                        <BaselinePushdownForm
                            pushdownLocations={this.state.pushdownLocationList}
                            updateLocationsToPush={this.updateLocationsToPush}
                            isFormValid={this.state.isPushdownFormValid}
                            projectEnabled={this.state.projectEnabled}
                            isLoading={this.state.isPushdownLoading}
                        />
                    </Drawer> : null}
                {this.state.copyBaselineDrawerOpen ?
                    <BaselineCopyDrawer
                        orginBaselineName={this.state.editBaseline.name}
                        isLoading={this.state.isCopyLoading}
                        copyBaseline={this.copyBaseline}
                        cancelClick={this.cancelClick}
                    />
                    : null}
                <LoadingIndicator isLoading={this.state.isFetching || this.state.isSaving} hideWhileLoading={true}>
                    <div className='container-fluid'>
                        <div className="row align-items-center justify-content-between mt-2 mb-2">
                            <div className="col-6">
                                <h4>
                                    <strong>Baselines</strong>
                                </h4>
                            </div>
                            <div className="col-6 d-lg-none">
                                <button
                                    className="btn-close float-end"
                                    type="button"
                                    onClick={this.props.onClose}
                                    aria-label="Close"
                                >
                                    <Icon name="times" />
                                </button>
                            </div>

                            <div className="col-lg-6 d-flex justify-content-end gap-3 pe-0">
                                <a className="d-flex align-items-center icon-link icon-link-hover text-decoration-none" href={Routes.CrossBaselineTaskLinkSearch}>
                                    <Icon name="link" />
                                    Link Search
                                </a>

                                <a className="d-flex align-items-center icon-link icon-link-hover text-decoration-none" href={Routes.CrossBaselineSearch}>
                                    <Icon name="search" />
                                    Task Search
                                </a>

                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={this.onAddNew}
                                >
                                    <span className="me-2">Add New</span>
                                    <Icon name="plus-circle" />
                                </button>
                            </div>
                        </div>


                        <div className="row identifier-results-table">
                            <DataTable
                                filterDisplay="row"
                                className="p-datatable-sm p-datatable-striped"
                                value={this.state.baselines}
                                selectionMode="single"
                                selection={this.state.selectedBaseline}
                                onSelectionChange={this.selectBaseline}
                                sortField={sortField}
                                sortOrder={sortOrder}
                                onSort={this.onSort} >
                                <Column field="name" header="Name" filter={true} filterElement={this.nameFilterElement()} sortable={true} />
                                <Column field="description" header="Description" filter={true} filterElement={descriptionFilterElement} style={{ display: displayColumns }} sortable={true} />
                                <Column field="isActive" header="Active" body={this.activeTemplate} style={{ width: '120px' }} filter={true} filterElement={activeFilter} sortable={true} />
                                <Column field="dotdotdot" header="Actions" body={this.actionTemplate} style={{ width: '6em' }} />
                            </DataTable>
                            {
                                this.state.totalCount > this.state.searchParams.pageSize &&
                                <Paginator
                                    rows={this.state.searchParams.pageSize}
                                    totalRecords={this.state.totalCount}
                                    first={(this.state.searchParams.pageNumber - 1) * this.state.searchParams.pageSize}
                                    onPageChange={this.onPageChange} />
                            }
                            <div className="results-count">Total records: {this.state.totalCount}</div>
                        </div>
                    </div>
                </LoadingIndicator>
            </div>
        );
    }

}

Baselines.propTypes = {
    windowWidth: PropTypes.number.isRequired,
    subscriptionId: PropTypes.number.isRequired,
    actions: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
}

const mapStateToProps = (state, ownProps) => {
    return {
        windowWidth: state.window.width,
        history: ownProps.history
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Baselines));

